import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from '@app/App';
import { AppProviders } from '@app/providers';
import '@shared/styles/tailwind.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root in index.html');

// StrictMode lives INSIDE AppProviders, not outside. react-oidc-context's AuthProvider runs the
// Cognito code-exchange in a mount effect; under StrictMode that effect fires twice in dev, and the
// second call tries to spend an already-consumed authorization code → the /auth/callback page hangs.
// AuthProvider must mount once; all non-OIDC children still get StrictMode's checks.
createRoot(rootElement).render(
  <BrowserRouter>
    <AppProviders>
      <StrictMode>
        <App />
      </StrictMode>
    </AppProviders>
  </BrowserRouter>,
);
